// extracted by mini-css-extract-plugin
module.exports = {"dynamicLpContainer":"DynamicLandingPageContainer_dynamicLpContainer__RALka","pageWidth":"DynamicLandingPageContainer_pageWidth__2QJau"};